import Api from '../api';

const { axios: api } = Api;

export const getStudioQuizOptions = async (language) => {
	const data = await api.get('/studio/quiz-options', {
		params: language ? { language } : undefined,
	});
	return { data: data.data };
};
